import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ManagedSettingsStoreActions } from '../../../../shared/managed-settings-store/index';

import { SetWallpaperComponent } from '@rocksoft/shared';
import { Wallpaper } from '../../../../models/wallpaper.model';

@Component({
  selector: 'ml-set-wallpaper',
  templateUrl: './set-wallpaper.container.html',
  imports: [SetWallpaperComponent],
})
export class SetWallpaperContainerComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  private udid: string;

  // TODO: Refactor to getting the UDID with NGRX later.
  private readonly subscriptions: Subscription[] = [];

  setWallpaper(wallpaper: Wallpaper) {
    this.store.dispatch(
      ManagedSettingsStoreActions.ManagedSettingsCommandActions.setWallpaper({
        wallpaper,
        udid: this.udid,
      })
    );
  }

  ngOnInit() {
    if (!this.route.parent) {
      return;
    }

    this.subscriptions.push(
      this.route.parent.params
        .pipe(
          map((p: Params) => p.udid),
          filter((udid) => udid),
          distinctUntilChanged()
        )
        .subscribe((id) => (this.udid = id))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
